<!-- src/pages/projects/create.vue -->
<template>
  <form @submit.prevent="handleSubmit">
    <section class="container">
      <div class="row">
        <div class="col">
          <div class="mb-2 d-sm-flex align-items-center justify-content-between">
            <h2 class="mb-sm-0">{{ $t('page.projects.create_title') }}</h2>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <div class="d-flex justify-content-between">
            <div>
              <h3 class="card-title"></h3>
              <p class="card-title-desc"></p>
            </div>
            <div>
              <button class="btn btn-sm btn-primary me-2" id="home" @click.prevent="handleIndex()" :title="$t('common.home')">
                <i class="fa fa-home"></i> {{ $t('common.home') }}
              </button>
              <button class="btn btn-sm btn-success" id="save" type="submit" :title="$t('common.save')">
                <i class="fa fa-save"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <Form v-model:form="form" :errors="errors" />
        </div>
        <div class="card-footer">
          <div class="text-center">
            <button class="btn btn-sm btn-success" type="submit"><i class="fa fa-save"></i> {{ $t('common.create') }}</button>
          </div>
        </div>
      </div>
    </section>
  </form>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from 'vue-router';
import { useProjectStore } from '@/stores/projectStore';
import { useI18n } from 'vue-i18n';
import { toast } from 'vue3-toastify';
import Form from './_form';

const router = useRouter();
const projectStore = useProjectStore();
const { t } = useI18n();
const form = ref({});
const errors = ref({});

// Submit
const handleSubmit = async () => {
  try {
    await projectStore.createProject(form.value);
    await toast.success(t('common.created'), { autoClose: 3000 });
    router.push({ name: 'projects-index' });
  } catch (error) {
    if (error.response.data.errors) {
      errors.value = error.response.data.errors;
    }
    toast.error(t('common.createError'));
  }
};

// Go to Index
const handleIndex = () => {
    router.push({ name: "projects-index" });
};
</script>

<style scoped></style>